import CustomTableRow from './CustomTableRow.component';

export default CustomTableRow;
